/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/

import Grid from '@mui/material/Grid'
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui';
import { IMAGES } from '../../config/assets';


// Footer component for the page
const PageFooter = () => {
  const { classes } = useStyles(); // Using custom styles

  return (
    <>
      {/* Footer section */}
      <div className={classes.root}>
        <Container maxWidth="xl" component="footer">
          <Grid container spacing={4} justify="space-evenly">
            {/* Empty grid space for layout alignment */}
            <Grid item xs={12} sm={12} md={2} />

            {/* Logo section */}
            <Grid item xs={12} sm={6} md={3}>
              <Link to="/">
                <img src={IMAGES.logo} alt="" height="60px" />
              </Link>
            </Grid>

            {/* Footer links */}
            <Grid item xs={12} sm={6} md={7}>
              <Link to="/contact-us" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  Contact us
                </Typography>
              </Link>
              <Link to="/about-us" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  About us
                </Typography>
              </Link>
              <Link to="/privacypolicy" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  Privacy Policy
                </Typography>
              </Link>
              <Link to="/tos" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  Terms of use
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </div>

      {/* Footer copyright section */}
      <div className={classes.footerdiv}>
        <Typography variant="h4" align="center" color="white" p={2}>
          Copyright © 2025 Bula Technologies, Inc. All rights reserved.
        </Typography>
      </div>
    </>
  );
};
// Custom styles using Material-UI's makeStyles
const useStyles = makeStyles({ name: { PageFooter } })((theme) => ({
  root: {
    position: 'relative',
    background: theme.palette.background.dark,
    paddingTop: '30px',
    color: 'white',
    marginTop: '130px',
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
  },
  footerdiv: {
    background: theme.palette.background.dark,
    paddingBottom: "10px"

  },
  listItemLink: {
    lineHeight: '25px',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)',
    textDecoration: 'none',
    color: 'white',
    width: 'fit-content',
    display: 'inline-block',
    marginLeft: '20px',
    marginTop: '16px',
  },
  itemLink: {
    lineHeight: '25px',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)',
    textDecoration: 'none',
    color: 'white',
    width: 'fit-content',
    display: 'inline-block',
    marginLeft: '10px',
    marginTop: '16px',
  },
}));


export default PageFooter;
